import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../styles/style.css";
import HeaderSerene from "../components/HeaderSerene";
import HeroSection from "../components/HeroSerene-2"
import ConstructionProgress from "../components/ConstructionProgressSerene"
import AboutSectionTwo from "../components/AboutSerene-2"
import AboutSectionThree from "../components/About-2"
import HighlightsSection from "../components/HighlightsSerene"
import LegendsSections from "../components/MasterPlanWithLegend"
import MasterPlanPreview from "../components/MasterPlanPreview"
import LocationSection from "../components/LocationSerene"
import ClubHouseSection from "../components/ClubhouseSerene"
import ApprovedBanks from "../components/ApprovedBanks"
import ContactSection from "../components/ContactSerene"
import SpecificationsSection from "../components/SpecificationSerene"
import SpecificationsSerene from "../components/SpecificationAccordion"
import GallerySerene from "../components/GallerySerene";
import AboutSerene from "../components/AboutSerene";


function SereneSite() {


    return (
        <section id="home-serene">
            {/* Header visible only in home */}
            <HeaderSerene />
            <HeroSection />
            <AboutSectionTwo />
            <AboutSerene />
            {/* <AboutSectionThree /> */}
            <MasterPlanPreview />

            {/* <HighlightsSection /> */}
            <ClubHouseSection />
            <GallerySerene />

            <LegendsSections />

            {/* <SpecificationsSection /> */}
            <LocationSection />
            <ConstructionProgress />

            <SpecificationsSerene />

            <ApprovedBanks />
            <ContactSection />




        </section>
    );
}

export default SereneSite;
